import axios from "axios";

const viacep = axios.create({
  baseURL: "https://viacep.com.br/ws/" //desenvolvimento
  // baseURL: "https://viacep.com.br/ws/" //produção
});

export default viacep;
